/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';
import type { DatabaseSubDbListSource } from './DatabaseSubDbListSource';
import {
    DatabaseSubDbListSourceFromJSON,
    DatabaseSubDbListSourceFromJSONTyped,
    DatabaseSubDbListSourceToJSON,
} from './DatabaseSubDbListSource';
import type { DatabaseSubDbTableCompare } from './DatabaseSubDbTableCompare';
import {
    DatabaseSubDbTableCompareFromJSON,
    DatabaseSubDbTableCompareFromJSONTyped,
    DatabaseSubDbTableCompareToJSON,
} from './DatabaseSubDbTableCompare';

/**
 * BAUSTEIN „TABELLE AUS UNTERDATENBANK" (Betreiber 11.09.2026).
 * 
 * Zeilen aus einer Unterdatenbank, Spalten aus ihren Feldern, und je
 * Zelle ein Farbvergleich gegen einen Sollwert.
 * 
 * WARUM ALLGEMEIN: Soll-Ist-Vergleich mit Ampelfarben ist die haeufigste
 * Auswertung ueberhaupt — Budget gegen Plan, Ist gegen Ziel, Verbrauch
 * gegen Norm, Schlaege gegen Bahn-Norm.
 * 
 * DER SOLLWERT KANN AUS EINER ANDEREN UNTERDATENBANK KOMMEN. Beim
 * Bahnengolf stehen die Schlaege beim Spieler, die Norm aber bei der
 * Bahn. Ein Vergleichswert je SPALTE, gelesen aus einer zweiten
 * Unterdatenbank, loest das — und deckt ebenso „Plan je Monat gegen Ist
 * je Monat" ab.
 * @export
 * @interface DatabaseSubDbTablePageBlock
 */
export interface DatabaseSubDbTablePageBlock extends DatabasePageBlock {
    /**
     * Was dasteht, wenn die Tabelle keine Zeilen hat. Ohne Angabe
     * steht dort nichts — so wie bisher.
     * 
     * Dieselbe Begruendung wie beim Listen-Baustein: Eine leere
     * Tabelle ist sonst eine weisse Flaeche ohne ein Wort, was zu
     * tun ist. Auf der Minigolf-Karte war das die halbe Seite
     * „Gesamtuebersicht", solange keine Mitspieler eingetragen
     * waren.
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    emptyText?: string;
    /**
     * Unterdatenbank, die die ZEILEN liefert.
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    childDatabaseId?: string;
    /**
     * 
     * @type {DatabaseSubDbListSource}
     * @memberof DatabaseSubDbTablePageBlock
     */
    source?: DatabaseSubDbListSource;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    fixedEntryId?: string;
    /**
     * Feld, das die Zeile benennt (etwa der Spielername).
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    rowLabelFieldId?: string;
    /**
     * Felder, die je eine Spalte bilden — in dieser Reihenfolge.
     * @type {Array<string>}
     * @memberof DatabaseSubDbTablePageBlock
     */
    columnFieldIds?: Array<string>;
    /**
     * Spalte „Summe" am rechten Rand.
     * @type {boolean}
     * @memberof DatabaseSubDbTablePageBlock
     */
    showSumColumn?: boolean;
    /**
     * Zeile „Summe" am unteren Rand.
     * @type {boolean}
     * @memberof DatabaseSubDbTablePageBlock
     */
    showSumRow?: boolean;
    /**
     * ACHSEN TAUSCHEN: Zeilen werden Spalten.
     * 
     * Ohne den Schalter steht je DATENSATZ eine Zeile und je Feld
     * eine Spalte — bei einer Scorecard also 18 Spalten, und die
     * passen auf kein Telefon. Getauscht steht je FELD eine Zeile
     * („Bahn 1" … „Bahn 18") und je Datensatz eine Spalte; der
     * Vergleichswert wird dann zur ersten SPALTE statt zur Kopfzeile,
     * die Summen zur letzten ZEILE.
     * 
     * So sieht es im Prototyp des Betreibers aus — und so liest es
     * sich auf einem Telefon, ohne zu schieben.
     * @type {boolean}
     * @memberof DatabaseSubDbTablePageBlock
     */
    transponieren?: boolean;
    /**
     * 
     * @type {DatabaseSubDbTableCompare}
     * @memberof DatabaseSubDbTablePageBlock
     */
    compareSource?: DatabaseSubDbTableCompare;
    /**
     * Nur bei `compareSource: FIXED` — derselbe Sollwert fuer jede Spalte.
     * @type {number}
     * @memberof DatabaseSubDbTablePageBlock
     */
    compareValue?: number;
    /**
     * Nur bei `compareSource: OTHER_SUB_DB` — Unterdatenbank, aus der
     * die Sollwerte kommen. Ihr n-ter Datensatz gehoert zur n-ten
     * Spalte.
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    compareDatabaseId?: string;
    /**
     * Feld dort, das den Sollwert traegt.
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    compareValueFieldId?: string;
    /**
     * Feld, nach dem die Sollwert-Datensaetze geordnet werden, bevor
     * sie den Spalten zugeteilt werden. Ohne Angabe gilt die
     * Reihenfolge der Liste.
     * @type {string}
     * @memberof DatabaseSubDbTablePageBlock
     */
    compareSortFieldId?: string;
    /**
     * Wahr = kleiner-gleich dem Sollwert ist gut (Schlaege, Kosten,
     * Verbrauch). Falsch = groesser-gleich ist gut (Umsatz, Punkte).
     * @type {boolean}
     * @memberof DatabaseSubDbTablePageBlock
     */
    lowerIsBetter?: boolean;
    /**
     * Zeile mit den Sollwerten ueber der Tabelle.
     * @type {boolean}
     * @memberof DatabaseSubDbTablePageBlock
     */
    showCompareRow?: boolean;
}

/**
 * Check if a given object implements the DatabaseSubDbTablePageBlock interface.
 */
export function instanceOfDatabaseSubDbTablePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSubDbTablePageBlockFromJSON(json: any): DatabaseSubDbTablePageBlock {
    return DatabaseSubDbTablePageBlockFromJSONTyped(json, false);
}

export function DatabaseSubDbTablePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbTablePageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'emptyText': !exists(json, 'emptyText') ? undefined : json['emptyText'],
        'childDatabaseId': !exists(json, 'childDatabaseId') ? undefined : json['childDatabaseId'],
        'source': !exists(json, 'source') ? undefined : DatabaseSubDbListSourceFromJSON(json['source']),
        'fixedEntryId': !exists(json, 'fixedEntryId') ? undefined : json['fixedEntryId'],
        'rowLabelFieldId': !exists(json, 'rowLabelFieldId') ? undefined : json['rowLabelFieldId'],
        'columnFieldIds': !exists(json, 'columnFieldIds') ? undefined : json['columnFieldIds'],
        'showSumColumn': !exists(json, 'showSumColumn') ? undefined : json['showSumColumn'],
        'showSumRow': !exists(json, 'showSumRow') ? undefined : json['showSumRow'],
        'transponieren': !exists(json, 'transponieren') ? undefined : json['transponieren'],
        'compareSource': !exists(json, 'compareSource') ? undefined : DatabaseSubDbTableCompareFromJSON(json['compareSource']),
        'compareValue': !exists(json, 'compareValue') ? undefined : json['compareValue'],
        'compareDatabaseId': !exists(json, 'compareDatabaseId') ? undefined : json['compareDatabaseId'],
        'compareValueFieldId': !exists(json, 'compareValueFieldId') ? undefined : json['compareValueFieldId'],
        'compareSortFieldId': !exists(json, 'compareSortFieldId') ? undefined : json['compareSortFieldId'],
        'lowerIsBetter': !exists(json, 'lowerIsBetter') ? undefined : json['lowerIsBetter'],
        'showCompareRow': !exists(json, 'showCompareRow') ? undefined : json['showCompareRow'],
    };
}

export function DatabaseSubDbTablePageBlockToJSON(value?: DatabaseSubDbTablePageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'emptyText': value.emptyText,
        'childDatabaseId': value.childDatabaseId,
        'source': DatabaseSubDbListSourceToJSON(value.source),
        'fixedEntryId': value.fixedEntryId,
        'rowLabelFieldId': value.rowLabelFieldId,
        'columnFieldIds': value.columnFieldIds,
        'showSumColumn': value.showSumColumn,
        'showSumRow': value.showSumRow,
        'transponieren': value.transponieren,
        'compareSource': DatabaseSubDbTableCompareToJSON(value.compareSource),
        'compareValue': value.compareValue,
        'compareDatabaseId': value.compareDatabaseId,
        'compareValueFieldId': value.compareValueFieldId,
        'compareSortFieldId': value.compareSortFieldId,
        'lowerIsBetter': value.lowerIsBetter,
        'showCompareRow': value.showCompareRow,
    };
}

